import { render } from "./EmpresaShow.vue?vue&type=template&id=423e4ae2"
import script from "./EmpresaShow.vue?vue&type=script&lang=js"
export * from "./EmpresaShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__